var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',[_c('div',{staticClass:"loader-overlay",staticStyle:{"position":"fixed !important"},attrs:{"id":"point-loader"}},[_c('div',{staticStyle:{"height":"100%","display":"flex","justify-content":"center","align-items":"center"}},[_c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":60,"color":'#e20101'}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d84fc0e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 265
// module chunks = 0